import { useEffect } from 'react';
import { useMapContext } from 'widgets/earthMap/contexts/mapContext';
import * as turf from 'turf';
import { MAP_SOURCE_NAME, SEPARATED_SOURCE_NAME } from 'widgets/earthMap/constants/mapConstants';

export default function useHoverEvent({ layerName, sourceName }: { layerName: string; sourceName: string }) {
	const [{ map, isClustered }, { setHoveredCluster }] = useMapContext();

	useEffect(() => {
		if (!map) return;
		const source = map.getSource(sourceName);
		if (!source) return;
		const layer = map.getLayer(layerName);
		if (!layer) return;
		const onMouseMove = (e: any) => {
			const features = map.queryRenderedFeatures(e.point, { layers: [layerName] });
			let minDistance = undefined;
			let minFeature = undefined;
			const cursorPoint = turf.point([e.lngLat.lng, e.lngLat.lat]);
			features.forEach((feature: any) => {
				const point = turf.point(feature.geometry.coordinates);
				const distance = turf.distance(cursorPoint, point);
				if (minDistance === undefined || distance < minDistance) {
					minDistance = distance;
					minFeature = feature;
				}
			});
			setHoveredCluster(minFeature);
		};
		if (sourceName === MAP_SOURCE_NAME && isClustered) map.on('mousemove', onMouseMove);
		if (sourceName === SEPARATED_SOURCE_NAME && !isClustered) map.on('mousemove', onMouseMove);
		return () => {
			map.off('mousemove', onMouseMove);
		};
	}, [map, isClustered, layerName, setHoveredCluster, sourceName]);
}
